import styles from './Toggle.module.css';

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

export function Toggle({ checked, onChange, disabled }: ToggleProps) {
  return (
    <label className={`${styles.toggle} ${checked ? styles.on : ''} ${disabled ? styles.disabled : ''}`}>
      <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} disabled={disabled} className={styles.input} />
      <span className={styles.track}><span className={styles.thumb} /></span>
    </label>
  );
}
